import React from 'react';
import { Card, Row, Col, Table, Progress } from 'antd';
import { formatWholeNumberNaN } from '../../../../../../../core/utils/campaigns';
import DonutChart from '../../../../../../shared/charts/DonutChart';

const SessionDeviceBreakdown = ({
  data = {
    desktop: 0,
    mobile: 0,
    tablet: 0,
  },
}) => {
  const total = data.desktop + data.mobile + data.tablet;
  const dataSource = [
    {
      key: '1',
      device: 'Desktop',
      color: '#4CAF50',
      sessions: data.desktop,
      percentage: total > 0 ? (data.desktop / total) * 100 : 0,
    },
    {
      key: '2',
      device: 'Mobile',
      color: '#2196F3',
      sessions: data.mobile,
      percentage: total > 0 ? (data.mobile / total) * 100 : 0,
    },
    {
      key: '3',
      color: '#FF9800',
      device: 'Tablet',
      sessions: data.tablet,
      percentage: total > 0 ? (data.tablet / total) * 100 : 0,
    },
  ];
  const column = [
    {
      title: 'Device',
      dataIndex: 'device',
      key: 'device',
      render: (text, value) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: value.color,
                borderRadius: '50%',
                marginRight: 8,
              }}
            ></div>
            {text}
          </div>
        );
      },
    },
    {
      title: 'Sessions',
      dataIndex: 'sessions',
      key: 'sessions',
      render: (text) => {
        return formatWholeNumberNaN(text);
      },
    },
    {
      title: 'Percentage',
      dataIndex: 'percentage',
      key: 'percentage',
      render: (text, { color }) => {
        return (
          <>
            <Progress percent={text.toFixed(2)} strokeColor={color} status="active" />
          </>
        );
      },
    },
  ];
  return (
    <Row gutter={[16, 16]}>
      <Col span={18}>
        <Card title="Device Breakdown" bordered={false} style={{ width: '100%' }}>
          <Table columns={column} dataSource={dataSource} />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <DonutChart
            axisName="device"
            position="sessions"
            chartData={dataSource}
            showTooltip
            totalCount={total}
            showCenterText={true}
            centerText="Sessions"
          />
        </Card>
      </Col>
    </Row>
  );
};

export default SessionDeviceBreakdown;
